class AsyncManager {
  pending: Promise<any>[] = [];

  addPending(p: Promise<any>) {
    this.pending.push(p);
  }

  waitForPending() {
    const waiting = Promise.all(this.pending);
    this.pending = [];
    return waiting;
  }
}

export default new AsyncManager();
